import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';

import {
  SwitchingAccountComponent,
  SwitchingAccountDisplay
} from '@com-delta-idp/mnx-capability-profile-selector-ui';
import { PushPipe } from '@ngrx/component';
import { InterstitialFacadeService } from '../../data-access/facades/interstitial/interstitial-facade.service';

@Component({
  selector: 'idp-interstitial',
  standalone: true,
  imports: [CommonModule, SwitchingAccountComponent, PushPipe],
  templateUrl: './interstitial.component.html',
  styleUrls: ['./interstitial.component.scss']
})
export class InterstitialComponent implements OnInit {
  @Input() isDesktop = true;

  emptySwitchingAccountContentDetails: SwitchingAccountDisplay =
    {} as SwitchingAccountDisplay;

  facade = inject(InterstitialFacadeService);

  ngOnInit() {
    this.facade.init(this.isDesktop);
  }
}
